module.exports = __webpack_public_path__ + "static/media/example-07.8806cc65.jpg";